import React from "react";
import { Formik, Field, Form } from "formik";
import classNames from "classnames";
import { makeStyles } from "@material-ui/styles";
import validate from "./validate";
import { initialValues } from "./initialValues";
import { Row } from "../password/UIComponents";
import MuiTextInput from "../../Common/MuiTextInput";
import { Button } from "@mantine/core";

const useStyles = makeStyles((theme) => ({
  submit: {
    marginTop: "16px",
    borderTop: `1px solid ${theme.app.borderColor}`,
    padding: "8px 0",
    display: "grid",
    gridTemplateColumns: "1fr auto",
    alignItems: "center",
  },
  formActions: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    "& button": {
      marginLeft: "8px",
    },
  },
  button: { color: theme.app.labelColor },
}));

const RegisterTicketForm = ({ handleSubmit, language }) => {
  const classes = useStyles();
  return (
    <Formik
      initialValues={initialValues}
      onSubmit={(values, actions) => handleSubmit(values, actions)}
      validate={(values) => validate(values, language)}
      render={(props) => (
        <Form>
          <Row>
            <Field
              component={MuiTextInput}
              fullWidth={true}
              label={language.UniqueIdentifier}
              name="uniqueIdentifier"
              placeholder={`${language.UniqueIdentifier} (${language.Required})`}
              type="text"
              required={true}
            />
          </Row>
          <div className={classes.submit}>
            <div>
              <Button
                className={classes.button}
                onClick={() => window.history.back()}
                variant="subtle"
                color="dark"
              >
                {language.Back}
              </Button>
            </div>
            <div className={classes.formActions}>
              <Button
                disabled={!props.isValid || props.isSubmitting}
                type="submit"
                className={classNames(
                  classes.submitButton,
                  "register-ticket__submit-button primaryButton"
                )}
              >
                {language.Register}
              </Button>
            </div>
          </div>
        </Form>
      )}
    />
  );
};

export default RegisterTicketForm;
